import React, {useCallback, useState} from 'react';
import {useSelector, useDispatch} from 'react-redux';

import {campaignDataSelector, campaignHeadDataSelector} from '../redux/selectors';

import DestinationTrendingUI from '../../../../stories/components/hotels/HomePage/DestinationTrending/DestinationTranding';
import scrollToTop from '../../../utils/scrollToTop';
import {IUpdate_Query, UPDATE_QUERY} from '../../common/redux/types';
import {useNavigateForSearchWidget} from '../../../hooks/useNavigateForSearchWidget';

const DestinationTrending = () => {
    const dispatch = useDispatch();
    const campaignData = useSelector(campaignDataSelector);
    const campaignHead = useSelector(campaignHeadDataSelector);

    const updateQueryCaller = useCallback(
        (actionData: IUpdate_Query['actionData']) => {
          return dispatch({type: UPDATE_QUERY, actionData});
        },
        [dispatch],
    );

    const [onSearch] = useNavigateForSearchWidget();
    
    return(
        <>
            {(campaignData.length  && campaignHead && (
                <DestinationTrendingUI 
                    data={campaignData}
                    headData={campaignHead}
                    actionHandler={item => {
                        if (!item || !item.city_name) return;
                        scrollToTop();
                        updateQueryCaller({
                            destination: {_id: item?.city_id, n: item?.city_name},
                        });
                        onSearch(false, null, {}, ['gostays']);
                    }}
                />
            )) || null}
        </>
    )
}

export default DestinationTrending;